import { TLanguageCode, TUserRole } from '../../../../store/models/types';

export interface IInstallSelectLangsFields {
  nativeCode: string,
  targetCode: string,
  userRoles: TUserRole[],
}

export interface IInstallSelectLangsEvents {
  onLoad: () => void;
  onSave: (nativeLangCode: TLanguageCode, targetLangCode: TLanguageCode, roles: number[]) => Promise<any>,
}

export interface IInstallSelectLangsProps extends IInstallSelectLangsFields, IInstallSelectLangsEvents
{}

export interface IInstallUserRoleCheckboxFields {
  id: number,
  title: string,
  checked: boolean
}

export interface IInstallUserRoleCheckboxEvents {
  onChange: () => void;
}

export interface IInstallUserRoleCheckboxProps extends IInstallUserRoleCheckboxFields, IInstallUserRoleCheckboxEvents {

}

export const INSTALL_USER_TEST_MODE = 'usertest'
